// RFC 5987 Content-Disposition for binary POSTs. ASCII filename= is the
// compatibility slot; filename* carries the real UTF-8 name. Kestrel 400s if
// filename= contains umlauts as raw header bytes.
export function contentDispositionAttachment(fileName) {
  const encoded = encodeURIComponent(fileName).replace(/[!'()*]/g, (c) =>
    "%" + c.charCodeAt(0).toString(16).toUpperCase()
  );
  const ascii = fileName
    .normalize("NFKD")
    .replace(/[^\x20-\x7E]/g, "_")
    .replace(/["\\]/g, "_") || "file";
  return `attachment; filename="${ascii}"; filename*=UTF-8''${encoded}`;
}
